export const menuUrl = (baseUrl: string, menuId: number) => `${baseUrl}/menu/${menuId}`;

export const mealUrl = (baseUrl: string, mealId: number) => `${baseUrl}/meal/${mealId}`;

export const productUrl = (baseUrl: string, productId: number) => `${baseUrl}/product/${productId}`;
